import { render, staticRenderFns } from "./EmbroideryTypes.vue?vue&type=template&id=42136ee3&"
import script from "./EmbroideryTypes.vue?vue&type=script&lang=js&"
export * from "./EmbroideryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports